// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3Jsfr","modalFooterButton":"ModalNotes_modalFooterButton__1Lqc_"};